// extracted by mini-css-extract-plugin
export default {"role":"Roles_role__kERip","infoButton":"Roles_infoButton__-ilSB","avatar":"Roles_avatar__Mai-9","info":"Roles_info__5IZeg","active":"Roles_active__NOPST"};